import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import { getCookie } from "../../slidebar/components/DarkMode";
import * as actions from "../redux/RefundNPromotionAction";

export const ProceedDialog = ({
  setSwalProps,
  refundList,
  setShow,
  show,
  isClassic,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [password, setPassword] = useState("");
  const [mode, setMode] = useState(getCookie("selectedTheme"));
  const refundNPromotionState = useSelector(
    ({ refundNPromotion }) => refundNPromotion,
    shallowEqual
  );

  const handleClose = () => setShow(false);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  const handleProceedClick = () => {
    const queryParams = {
      action: isClassic ? "memberrefundpublish_classic" : "memberrefundpublish",
      password: `${password}`,
      refundjson: refundList,
    };

    const dispatchAction = isClassic
      ? actions.memberRefundProcessClassic(queryParams)
      : actions.memberRefundProcess(queryParams);
    dispatch(dispatchAction).then((resp) => {
      resp = resp.data;
      setPassword("");
      if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
        setSwalProps({
          show: true,
          icon: "success",
          title: intl.formatMessage({ id: "success" }),
          text: intl.formatMessage(
            { id: "totalRefundX" },
            { X: resp.totalrefund }
          ),
          onResolve: () => {
            navigate("/memberRefund/memberRefundHistory");
          },
        });
      } else {
        setSwalProps({
          show: true,
          icon: "error",
          title: intl.formatMessage({ id: "error" }),
          text: resp.message,
        });
      }
    });
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  useEffect(() => {
    if (show) {
      setPassword("");
    }
  }, [show]);

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Modal show={show} onHide={handleClose} centered data-bs-theme={mode}>
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "confirmProceed",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="proceed-Input"
            placeholder={intl.formatMessage({ id: "password" })}
            onChange={handlePasswordChange}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
            }}
            value={password}
          />
        </Modal.Body>
        <Modal.Footer>
          {refundNPromotionState.actionsLoading && (
            <div
              className="spinner-border me-2"
              role="status"
              style={{ scale: "0.55" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          )}
          <button
            type="button"
            disabled={refundNPromotionState.actionsLoading}
            className="btn btn-primary px-3"
            onClick={handleProceedClick}
          >
            {intl.formatMessage({ id: "proceed" })}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
